import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle, GestureResponderEvent } from 'react-native'

const Body: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
  onPress?: (event: GestureResponderEvent) => void;
}> = ({ children, style, testID, onPress }) => {
  return (
    <Text
      testID={testID}
      fontSize="sm"
      fontWeight={400}
      fontFamily="Lato"
      style={style}
      onPress={onPress}
    >
      {children}
    </Text>
  )
}

export default Body
